"use client";

import { useTranslations } from "next-intl";
import {
    Box,
	Stack,
	Typography,
	useTheme,
} from "@/components/controls/base-controls";

import {
	HEADER_HEIGHT_FULL,
	WEBPAGE_CORE_CONTAINER
} from "@/core/constants/webpages";

const HomeBanner = () => {
    const theme = useTheme();
	const t = useTranslations();

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                ...theme.mixins.bgImage({
                    xs: { src: "https://general-images.navairra.com/planeclouds_420x900.png", height: '100svh' },
                    sm: { src: "https://general-images.navairra.com/planeclouds_900x420.png", height: '100svh' },
                    md: { src: "https://general-images.navairra.com/planeclouds_1200x428.png", height: `calc(100svh - ${HEADER_HEIGHT_FULL})` },
                    lg: { src: "https://general-images.navairra.com/planeclouds_1920x680.png", height: `calc(100svh - ${HEADER_HEIGHT_FULL})` },
                    xl: { src: "https://general-images.navairra.com/planeclouds_2538x900.png", height: `calc(100svh - ${HEADER_HEIGHT_FULL})` },
                }),
                height: {
                    xs: '100svh',
                    md: `calc(100vh - ${HEADER_HEIGHT_FULL})`,
                },
                width: "100%",
                "&::before": {
                    content: '""',
                    flexBasis: { xs: "42%", sm: "32%", md: "38%" },
                },
            }}
        >
            <Stack direction="column" sx={{
                lineHeight: 1,
                margin: "0 auto",
                padding: "0 1em",
                width: WEBPAGE_CORE_CONTAINER,
                maxWidth: "100%"
            }}>
                <Typography
                    variant="banner"
                    sx={{
                        color: "var(--mui-palette-lightest)",
                    }}
                >
                    {t("introBanner.line1")}
                </Typography>

                <Typography
                    variant="banner"
                    sx={{
                        color: "var(--mui-palette-lightest)",
                        mt: { xs: ".5em", md: 0 },
                    }}
                >
                    {t("introBanner.line2")}
                </Typography>

                <Typography
                    variant="h3"
                    sx={{
                        marginTop: { xs: "2em", md: "3em" },
                        paddingLeft: ".3em",
                        color: "var(--mui-palette-lightest)"
                    }}
                >
                    {t("introBanner.line3")}
                </Typography>
            </Stack>
        </Box>
    );
}

export default HomeBanner;
